module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serial-form"
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Live Class',
          to: {
            path: '/live-class'
          },
          exact: true,
        },
        {
          text: 'Tambah Live Class'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(_vm.$route.query.id ? "Ubah" : "Tambah") + " Live Class\n    ")]), _vm._v(" "), (_vm.$route.query.id) ? _c('v-layout', {
    staticClass: "pt-0 px-0 pb-3 mb"
  }, [_c('v-btn', {
    staticClass: "mr-2",
    class: _vm.tab == 1 ? 'white--text' : 'darkFade--text',
    attrs: {
      "color": _vm.tab == 1 ? 'blew' : 'white',
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("Detail Kelas")]), _vm._v(" "), _c('v-btn', {
    class: _vm.tab == 2 ? 'white--text' : 'darkFade--text',
    attrs: {
      "color": _vm.tab == 2 ? 'blew' : 'white',
      "cldass": "mr-2",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        _vm.tab = 2
      }
    }
  }, [_vm._v("Partisipan")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2 ml-2",
    class: _vm.tab == 3 ? 'white--text' : 'darkFade--text',
    attrs: {
      "color": _vm.tab == 3 ? 'blew' : 'white',
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        _vm.tab = 3
      }
    }
  }, [_vm._v("Upload Video dan Modul")])], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 1),
      expression: "tab == 1"
    }],
    staticStyle: {}
  }, [_c('v-card-title', [_vm._v("\n            Detail Kelas\n            "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card', {
    staticClass: "d-flex",
    attrs: {
      "flat": ""
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-card', {
    staticClass: "border-bottom-divider rounded-tl pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.form.url ?
        _vm.form.url :
        require('@/assets/img/unavailable.png')
    }
  })])])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-btn', {
    staticClass: "pa-0 font-weight-bold mt-3",
    attrs: {
      "block": "",
      "depressed": "",
      "color": "blew",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogUploadImageLiveClass = true
      }
    }
  }, [_vm._v("\n                            Pilih Gambar\n                        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "border-left": "1px solid #f0f0f0"
    },
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Nama Room *\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "live_class_title",
      "placeholder": "Nama Room",
      "required": "",
      "outlined": ""
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Tipe User ")]), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.form.user_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_type", $$v)
      },
      expression: "form.user_type"
    }
  }, [_c('v-radio', {
    staticClass: "user_type_selection",
    attrs: {
      "id": "user_type_student",
      "label": "Siswa",
      "value": "student",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "user_type_selection",
    attrs: {
      "id": "user_type_teacher",
      "label": "Guru",
      "value": "teacher",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "user_type_selection",
    attrs: {
      "id": "user_type_parent",
      "label": "Orang Tua",
      "value": "parent",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.form.user_type === 'student') ? _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Deskripsi\n                                ")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "id": "live_class_description",
      "placeholder": "Deskripsi Kelas",
      "outlined": ""
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.user_type !== 'student') ? _c('v-list-item', {
    staticClass: "mb-5",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Materi\n                                ")]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.form.material_description),
      callback: function($$v) {
        _vm.$set(_vm.form, "material_description", $$v)
      },
      expression: "form.material_description"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.user_type !== 'student') ? _c('v-list-item', {
    staticClass: "mb-5",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Manfaat Program\n                                ")]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.form.program_benefit),
      callback: function($$v) {
        _vm.$set(_vm.form, "program_benefit", $$v)
      },
      expression: "form.program_benefit"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Posisi ")]), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.orientation),
      callback: function($$v) {
        _vm.orientation = $$v
      },
      expression: "orientation"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "orientation_landscape",
      "label": "Landscape",
      "value": "landscape",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "orientation_potrait",
      "label": "Potrait",
      "value": "potrait",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0 mb-5"
  }, [(_vm.form.user_type === 'student') ? _c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Nama Guru *\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.form.user_type !== 'student') ? _c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Nama Narasumber *\n                                ")]) : _vm._e(), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "items": _vm.teacherList,
      "item-text": "name",
      "item-value": "name",
      "search-input": _vm.search,
      "placeholder": "Pilih atau ketik nama pengisi live class",
      "hide-selected": "",
      "hint": "Maksimal 4 nama",
      "multiple": "",
      "chips": "",
      "persistent-hint": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "pa-0"
        }, [_c('v-list-item-title', [_vm._v("\n                                                    Tidak ditemukan \""), _c('strong', [_vm._v(_vm._s(_vm.search))]), _vm._v("\". Tekan\n                                                    "), _c('strong', [_vm._v("enter")]), _vm._v("\n                                                    untuk input nama baru\n                                                ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.teachers),
      callback: function($$v) {
        _vm.teachers = $$v
      },
      expression: "teachers"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [(_vm.form.user_type !== 'student') ? _c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Detail Narasumber\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.form.user_type === 'student') ? _c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Detail Guru\n                                ")]) : _vm._e(), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "id": "live_class_teacher_details",
      "placeholder": "Deskripsi pengisi live class",
      "required": "",
      "outlined": ""
    },
    model: {
      value: (_vm.form.teacher_details),
      callback: function($$v) {
        _vm.$set(_vm.form, "teacher_details", $$v)
      },
      expression: "form.teacher_details"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Jenis Kelas ")]), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_type_free",
      "label": "Free",
      "value": "FREE",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_type_premium",
      "label": "Premium",
      "value": "PREMIUM",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.form.user_type === 'student') ? _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Mata Pelajaran\n                                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "id": "live_class_mapel",
      "items": _vm.mapelList,
      "outlined": "",
      "item-text": "nama",
      "item-value": "id",
      "placeholder": "Ketik mata pelajaran",
      "chips": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          staticClass: "pa-0 ma-0"
        }, [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])], 1)]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])]
      }
    }], null, false, 4151109516),
    model: {
      value: (_vm.form.mapel),
      callback: function($$v) {
        _vm.$set(_vm.form, "mapel", $$v)
      },
      expression: "form.mapel"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.user_type === 'student') ? _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Jenjang\n                                ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    on: {
      "change": function($event) {
        _vm.form.grade = []
      }
    },
    model: {
      value: (_vm.form.level),
      callback: function($$v) {
        _vm.$set(_vm.form, "level", $$v)
      },
      expression: "form.level"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_jenjang_sd",
      "label": "SD",
      "value": "SD",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_jenjang_smp",
      "label": "SMP",
      "value": "SMP",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_jenjang_sma",
      "label": "SMA",
      "value": "SMA",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.user_type === 'student') ? _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0 mb-5"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Kelas\n                                ")]), _vm._v(" "), (_vm.form.level === 'SD') ? _c('div', {
    staticClass: "d-inline d-flex",
    staticStyle: {
      "gap": "12px"
    }
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_1",
      "label": "1",
      "value": 1,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_2",
      "label": "2",
      "value": 2,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_3",
      "label": "3",
      "value": 3,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_4",
      "label": "4",
      "value": 4,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_5",
      "label": "5",
      "value": 5,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_6",
      "label": "6",
      "value": 6,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.level === 'SMP') ? _c('div', {
    staticClass: "d-inline d-flex",
    staticStyle: {
      "gap": "12px"
    }
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_7",
      "label": "7",
      "value": 7,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_8",
      "label": "8",
      "value": 8,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_9",
      "label": "9",
      "value": 9,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.level === 'SMA') ? _c('div', {
    staticClass: "d-inline d-flex",
    staticStyle: {
      "gap": "12px"
    }
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_10",
      "label": "10",
      "value": 10,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_11",
      "label": "11",
      "value": 11,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_kelas_12",
      "label": "12",
      "value": 12,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Youtube URL\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "live_class_youtube_url",
      "placeholder": "https://",
      "outlined": ""
    },
    model: {
      value: (_vm.form.youtubeUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "youtubeUrl", $$v)
      },
      expression: "form.youtubeUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                            Room Url\n                                        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "live_class_room_url",
      "placeholder": "https://",
      "outlined": ""
    },
    model: {
      value: (_vm.form.room_url),
      callback: function($$v) {
        _vm.$set(_vm.form, "room_url", $$v)
      },
      expression: "form.room_url"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                            ID Room\n                                        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "live_class_meeting_id",
      "placeholder": "ID Zoom",
      "outlined": ""
    },
    model: {
      value: (_vm.form.meeting_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "meeting_id", $$v)
      },
      expression: "form.meeting_id"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Room Password\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "live_class_room_password",
      "placeholder": "Password",
      "outlined": ""
    },
    model: {
      value: (_vm.form.room_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "room_password", $$v)
      },
      expression: "form.room_password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Join Code\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "live_class_join_code",
      "placeholder": "Maksimal 10 karakter",
      "value": _vm.form.joinCode =
        _vm.form.joinCode.toUpperCase(),
      "maxlength": "10",
      "outlined": ""
    },
    model: {
      value: (_vm.form.joinCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "joinCode", $$v)
      },
      expression: "form.joinCode"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Opsi\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline mb-5"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "id": "live_class_opsi_private",
      "label": "Private",
      "outlined": ""
    },
    model: {
      value: (_vm.form.isPrivate),
      callback: function($$v) {
        _vm.$set(_vm.form, "isPrivate", $$v)
      },
      expression: "form.isPrivate"
    }
  })], 1)], 1)], 1), _vm._v(" "), (
    _vm.form.type == 'PREMIUM' &&
    _vm.form.user_type === 'student'
  ) ? _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Jadwal Kelas\n                                ")]), _vm._v(" "), _vm._l((_vm.tryouts), function(tryout, index) {
    return _c('v-card', {
      key: index,
      staticClass: "my-3 test_cursor",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-list', {
      staticClass: "pa-2 text-subtitle-2"
    }, [
      [_c('v-list-item', {
        attrs: {
          "two-line": ""
        }
      }, [_c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start",
        staticStyle: {
          "max-width": "5%"
        }
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                                        ID\n                                                    ")]), _vm._v(" "), _c('v-list-item-subtitle', {
        staticStyle: {
          "text-overflow": "unset",
          "white-space": "unset"
        }
      }, [_vm._v("\n                                                        " + _vm._s(tryout.id) + "\n                                                    ")])], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start",
        staticStyle: {
          "max-width": "20%"
        }
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                                        Deskripsi\n                                                    ")]), _vm._v(" "), _c('v-list-item-subtitle', {
        staticStyle: {
          "text-overflow": "unset",
          "white-space": "unset"
        }
      }, [_vm._v("\n                                                        " + _vm._s(tryout.desc) + "\n                                                    ")])], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start",
        staticStyle: {
          "max-width": "10%"
        }
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                                        Kuota\n                                                    ")]), _vm._v(" "), _c('v-list-item-subtitle', {
        staticStyle: {
          "text-overflow": "unset",
          "white-space": "unset"
        }
      }, [_vm._v("\n                                                        " + _vm._s(tryout.quota) + "\n                                                    ")])], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start",
        staticStyle: {
          "max-width": "15%"
        }
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                                        Threshold\n                                                    ")]), _vm._v(" "), _c('v-list-item-subtitle', {
        staticStyle: {
          "text-overflow": "unset",
          "white-space": "unset"
        }
      }, [_vm._v("\n                                                        " + _vm._s(tryout.threshold) + "\n                                                    ")])], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start",
        staticStyle: {
          "max-width": "15%"
        }
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                                        Start Time\n                                                    ")]), _vm._v(" "), _c('v-list-item-subtitle', {
        staticStyle: {
          "text-overflow": "unset",
          "white-space": "unset"
        }
      }, [_vm._v("\n                                                        " + _vm._s(tryout.start_time) + "\n                                                    ")])], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start"
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                                        End Time\n                                                    ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                                                        " + _vm._s(tryout.end_time) + "\n                                                    ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
        staticClass: "pa-0",
        attrs: {
          "plain": ""
        },
        on: {
          "click": function($event) {
            return _vm.removeTryoutFromGroup(
              index
            )
          }
        }
      }, [_c('span', {
        staticClass: "red--text",
        class: _vm.$vuetify
          .breakpoint
          .mdAndUp ?
          'font-weight-700' :
          'font-weight-600',
        style: (_vm.$vuetify
          .breakpoint
          .smAndDown ?
          'font-size: 12px' :
          '')
      }, [_vm._v("Hapus")])])], 1)], 1)]
    ], 2)], 1)
  }), _vm._v(" "), _c('app-jadwalkelaschooser', {
    staticClass: "mb-8 mt-2",
    on: {
      "selected": function($event) {
        return _vm.addTryoutIntoGroup($event)
      }
    }
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "pa-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                Waktu Mulai *\n                                            ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "live_class_start_date",
                "append-icon": "mdi-calendar",
                "placeholder": "Tanggal",
                "outlined": ""
              },
              model: {
                value: (
                  _vm.startDate.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.startDate, "value", $$v)
                },
                expression: "\n                                                                        startDate.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.startDate.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.startDate, "option", $$v)
      },
      expression: "\n                                                                startDate.option\n                                                            "
    }
  }, [_vm._v(" "), (
    _vm.startDate.option
  ) ? _c('v-date-picker', {
    attrs: {
      "min": new Date()
        .toISOString()
        .slice(
          0,
          10
        ),
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.startDate.option = false
      }
    },
    model: {
      value: (
        _vm.startDate.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.startDate, "value", $$v)
      },
      expression: "\n                                                                    startDate.value\n                                                                "
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "live_class_start_time",
                "outlined": "",
                "placeholder": "Jam",
                "append-icon": "mdi-clock-time-four-outline"
              },
              model: {
                value: (
                  _vm.startTime.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.startTime, "value", $$v)
                },
                expression: "\n                                                                        startTime.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.startTime.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.startTime, "option", $$v)
      },
      expression: "\n                                                                startTime.option\n                                                            "
    }
  }, [_vm._v(" "), (
    _vm.startTime.option
  ) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "change": function($event) {
        _vm.startTime.option = false
      }
    },
    model: {
      value: (
        _vm.startTime.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.startTime, "value", $$v)
      },
      expression: "\n                                                                    startTime.value\n                                                                "
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                                Waktu Berakhir *\n                                            ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "live_class_end_date",
                "append-icon": "mdi-calendar",
                "placeholder": "Tanggal",
                "outlined": ""
              },
              model: {
                value: (
                  _vm.endDate.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.endDate, "value", $$v)
                },
                expression: "\n                                                                        endDate.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.endDate.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.endDate, "option", $$v)
      },
      expression: "\n                                                                endDate.option\n                                                            "
    }
  }, [_vm._v(" "), (
    _vm.endDate.option
  ) ? _c('v-date-picker', {
    attrs: {
      "min": new Date()
        .toISOString()
        .slice(
          0,
          10
        ),
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.endDate.option = false
      }
    },
    model: {
      value: (
        _vm.endDate.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.endDate, "value", $$v)
      },
      expression: "\n                                                                    endDate.value\n                                                                "
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "id": "live_class_end_time",
                "outlined": "",
                "placeholder": "Jam",
                "append-icon": "mdi-clock-time-four-outline"
              },
              model: {
                value: (
                  _vm.endTime.value
                ),
                callback: function($$v) {
                  _vm.$set(_vm.endTime, "value", $$v)
                },
                expression: "\n                                                                        endTime.value\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }]),
    model: {
      value: (
        _vm.endTime.option
      ),
      callback: function($$v) {
        _vm.$set(_vm.endTime, "option", $$v)
      },
      expression: "\n                                                                endTime.option\n                                                            "
    }
  }, [_vm._v(" "), (
    _vm.endTime.option
  ) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "change": function($event) {
        _vm.endTime.option = false
      }
    },
    model: {
      value: (
        _vm.endTime.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.endTime, "value", $$v)
      },
      expression: "\n                                                                    endTime.value\n                                                                "
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pt-0 px-0 pb-6"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    User Group *\n                                ")]), _vm._v(" "), _vm._l((_vm.form.user_group), function(usgr, i) {
    return _c('v-autocomplete', {
      key: i,
      staticClass: "pb-2",
      attrs: {
        "items": _vm.user_groups,
        "item-text": "user_group_name",
        "item-value": "id",
        "placeholder": "-- Pilih user group --",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function() {
          return [(
            i ===
            _vm.form.user_group.length -
            1 &&
            _vm.form.user_group.length != 1
          ) ? _c('v-btn', {
            staticClass: "font-weight-bold dark--text py-3",
            attrs: {
              "id": "user-remove-scope-btn",
              "dark": "",
              "x-large": "",
              "depressed": "",
              "color": "white",
              "elevation": "1"
            },
            on: {
              "click": function($event) {
                _vm.queryId
                  ?
                  null :
                  _vm.form.user_group.splice(
                    i,
                    1
                  )
              }
            }
          }, [_vm._v("\n                                            Hapus\n                                        ")]) : _vm._e()]
        },
        proxy: true
      }], null, true),
      model: {
        value: (_vm.form.user_group[i]),
        callback: function($$v) {
          _vm.$set(_vm.form.user_group, i, $$v)
        },
        expression: "form.user_group[i]"
      }
    })
  })], 2)], 1), _vm._v(" "), _c('v-container', [_c('v-btn', {
    staticClass: "font-weight-bold blew--text mb-5",
    attrs: {
      "id": "user-add-scope-btn",
      "block": "",
      "depressed": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": function($event) {
        return _vm.form.user_group.push('')
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("\n                                    mdi-plus-circle\n                                ")]), _vm._v("\n                                Tambah User Group Baru\n                            ")], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "depressed": "",
      "color": "blew",
      "id": "live_class_simpan"
    },
    on: {
      "click": function($event) {
        return _vm.upload()
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$route.query.id) ? _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 2),
      expression: "tab == 2"
    }],
    staticStyle: {}
  }, [_c('v-card-title', [_vm._v("\n            Daftar Partisipan\n\n            "), (_vm.countStudents) ? _c('v-btn', {
    staticClass: "darkGreen--text font-weight-600 ml-3",
    attrs: {
      "elevation": "0",
      "color": "backgroundGreen",
      "rounded": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi mdi-account-multiple-outline")]), _vm._v("\n                " + _vm._s(_vm.countStudents) + " Siswa\n            ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "search_box",
    attrs: {
      "outlined": "",
      "height": "36px",
      "hide-details": "",
      "small": "",
      "dense": "",
      "placeholder": "Ketik kata kunci dan tekan enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchMember()
      }
    },
    model: {
      value: (_vm.params.search),
      callback: function($$v) {
        _vm.$set(_vm.params, "search", $$v)
      },
      expression: "params.search"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Nama")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.students), function(student, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_c('v-btn', {
            staticClass: "user-avatar font-weight-500",
            staticStyle: {
              "text-transform": "uppercase !important",
              "letter-spacing": "0.5pt !important"
            },
            attrs: {
              "fab": "",
              "dark": "",
              "depressed": "",
              "x-small": "",
              "color": _vm.getColorAvatar(student.name)
            }
          }, [_vm._v("\n                                    " + _vm._s(_vm.getAcronimeName(student.name)) + "\n                                ")]), _vm._v(" "), _c('span', {
            staticClass: "ml-3"
          }, [_vm._v(_vm._s(student.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(student.email))]), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [(_vm.status == 'ATTENDED') ? _c('v-btn', {
            staticClass: "blew--text font-weight-600",
            attrs: {
              "color": "touchBlue",
              "rounded": "",
              "small": ""
            }
          }, [_vm._v("\n                                    Attended\n                                ")]) : _c('v-btn', {
            staticClass: "darkGreen--text font-weight-600",
            attrs: {
              "elevation": "0",
              "color": "backgroundGreen",
              "rounded": "",
              "small": ""
            }
          }, [_vm._v("\n                                    Joined\n                                ")])], 1)])
        }), _vm._v(" "), (!_vm.students.length && !_vm.isLoading) ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "3",
            "align": "center"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm.params.search ?
          "Partisipan tidak ditemukan" :
          "Tidak ada partisipan untuk Live Class ini") + "\n                            ")])]) : _vm._e()], 2)]
      },
      proxy: true
    }], null, false, 1542578664)
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-5",
    staticStyle: {
      "justify-content": "end"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "length": _vm.params.maxpage
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.query.id) ? _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 3),
      expression: "tab == 3"
    }],
    staticStyle: {}
  }, [_c('v-card', {
    staticClass: "pa-7",
    attrs: {
      "plain": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Youtube URL Recording\n                    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Masukkan URL Video dan tekan enter",
      "outlined": ""
    },
    model: {
      value: (_vm.form.youtubeUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "youtubeUrl", $$v)
      },
      expression: "form.youtubeUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Durasi Video\n                    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "Durasi (dalam detik)",
      "outlined": ""
    },
    model: {
      value: (_vm.record_video_duration),
      callback: function($$v) {
        _vm.record_video_duration = $$v
      },
      expression: "record_video_duration"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "px-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Upload Modul\n                    ")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "d-flex"
  }, [_c('div', [_c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.uploader2.click()
      }
    }
  }, [_vm._v("Upload File\n                                ")]), _vm._v(" "), _c('input', {
    ref: "uploader2",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.onFileChange2
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "ml-5 mb-5 mt-0 grey--text"
  }, [_vm._v("\n                            File dalam bentuk PDF dan maksimal ukuran file 2\n                            MB\n                        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.presentationPath) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "pdf-container ml-5"
  }, [_c('embed', {
    attrs: {
      "src": _vm.presentationPath,
      "type": "application/pdf",
      "width": "100%",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ml-5 mb-2 mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.presentationName) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "ml-5 mb-5 mt-0"
  }, [_vm._v("\n                    " + _vm._s(_vm.presentationSize) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-2"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.upload2()
      }
    }
  }, [_vm._v("\n                    Simpan\n                ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dialogUploadImageLiveClass) ? _c('app-upload-image-liveclass', {
    on: {
      "closeDialog": function($event) {
        _vm.dialogUploadImageLiveClass = false
      },
      "selected": function($event) {
        return _vm.selectedImage($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ef8bc65","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class/components/Form.vue
// module id = 1701
// module chunks = 1